import React from 'react';
import { TRACK_ID } from '@hugendubel/tracking_manager';
import { A } from '@hugendubel/react-basic';
import { __ } from 'first-intl';
import { ParticipationButton } from './ParticipationButton';
import { ExternalRoutes } from '../../appRoutes';

export type ParticipationRequiredProps = { finishParticipation: () => void };

export const ParticipationRequired: React.FC<ParticipationRequiredProps> = ({ finishParticipation }) => (
    <div className="container-fluid">
        <div className="row">
            <div className="col col-xs-12 newAccountOrGuest">
                <div className="message info">{__('participation.required')}</div>
                <div className="h2">
                    {__(
                        process.env.IS_HUDU
                            ? 'participation.benefit.headline.hudu'
                            : 'participation.benefit.headline.eBook'
                    )}
                </div>

                <ul className="benefit">
                    <li>
                        {__(process.env.IS_HUDU ? 'participation.benefit.1.hudu' : 'participation.benefit.1.eBook')}
                    </li>
                    <li>
                        {__(process.env.IS_HUDU ? 'participation.benefit.2.hudu' : 'participation.benefit.2.eBook')}
                    </li>
                    <li>{__('participation.benefit.3')}</li>
                    <li>{__('participation.benefit.4')}</li>
                    <li>{__('participation.benefit.5')}</li>
                    <li>{__('participation.benefit.6')}</li>
                </ul>
                <div className="buttons">
                    {process.env.IS_HUDU ? (
                        <A
                            trackId={TRACK_ID('2019-09-02 01:16:20')}
                            className="btn btn-primary btn-lg btn-mobile-lg"
                            href={ExternalRoutes.LOYALTY_REGISTRATION}
                            target="_self"
                        >
                            {__('participation.submit')}
                        </A>
                    ) : (
                        <ParticipationButton onFinish={finishParticipation} />
                    )}
                    <A
                        trackId={TRACK_ID('2019-09-02 01:16:49')}
                        className="btn btn-default"
                        href={ExternalRoutes.HOME}
                        target="_self"
                    >
                        {__('participation.cancel')}
                    </A>
                </div>
            </div>
        </div>
    </div>
);
